import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { useAuthContext } from "./hooks/useAuthContext";

// styles
import "./App.css";

// pages and componenets
import Dashboard from "./pages/dashboard/Dashboard";
import Login from "./pages/login/Login";
import Signup from "./pages/signup/Signup";
import Create from "./pages/create/Create";
import Project from "./pages/project/Project";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import OnlineUser from "./components/OnlineUser";
import Landing from "./pages/landing/Landing";

function App() {
  const { user, authIsReady } = useAuthContext();

  return (
    <div className="App">
      {authIsReady && (
        <BrowserRouter>
          {user && <Sidebar />}
          <div className="container">
            <Navbar />
            <Switch>
              <Route path="/" exact>
                {user && <Dashboard />}
                {!user && <Redirect to="/landing" />}
              </Route>
            </Switch>

            <Switch>
              <Route path="/create">
                {user && <Create />}
                {!user && <Redirect to="/landing" />}
              </Route>
            </Switch>

            <Switch>
              <Route path="/projects/:id">
                {user && <Project />}
                {!user && <Redirect to="/landing" />}
              </Route>
            </Switch>

            <Switch>
              <Route path="/landing">
                {!user && <Landing />}
                {user && <Redirect to="/" />}
              </Route>
            </Switch>

            <Switch>
              <Route path="/login">
                {!user && <Login />}
                {user && <Redirect to="/" />}
              </Route>
            </Switch>

            <Switch>
              <Route path="/signup">
                {!user && <Signup />}
                {user && <Redirect to="/" />}
              </Route>
            </Switch>
          </div>
          {user && <OnlineUser />}
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
